/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardThreatsByResourceCategoryResponse {
    getFixupPrototypeFunction() { return SecurityDashboardThreatsByResourceCategoryResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardThreatsByResourceCategoryResponse>): SecurityDashboardThreatsByResourceCategoryResponse {
        let obj = Object.assign(new SecurityDashboardThreatsByResourceCategoryResponse(), model);
        SecurityDashboardThreatsByResourceCategoryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardThreatsByResourceCategoryResponse>): SecurityDashboardThreatsByResourceCategoryResponse {
        if (!model) return null;
        return SecurityDashboardThreatsByResourceCategoryResponse.newInstance(<SecurityDashboardThreatsByResourceCategoryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardThreatsByResourceCategoryResponse) {
        if (!obj) return;

        models.SecurityDashboardThreatsByResourceCategoryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardThreatsByResourceCategoryResponse): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardThreatsByResourceCategoryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_provider_category) {
            for (let val of this.summary_by_provider_category) {
                models.SecurityDashboardThreatsByResourceCategoryCount.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the threats by CloudProvider
     */
    summary_by_provider_category: Array<models.SecurityDashboardThreatsByResourceCategoryCount>;

}
